import { render, staticRenderFns } from "./ModalConsultarPlaca.vue?vue&type=template&id=6f922772"
import script from "./ModalConsultarPlaca.vue?vue&type=script&lang=js"
export * from "./ModalConsultarPlaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports